export const oregonCountiesList = [
    'Baker',
    'Benton',
    'Clackamas',
    'Clatsop',
    'Columbia',
    'Coos',
    'Crook',
    'Curry',
    'Deschutes',
    'Douglas',
    'Gilliam',
    'Grant',
    'Harney',
    'Hood River',
    'Jackson',
    'Jefferson',
    'Josephine',
    'Klamath',
    'Lake',
    'Lane',
    'Lincoln',
    'Linn',
    'Malheur',
    'Marion',
    'Morrow',
    'Multnomah',
    'Polk',
    'Sherman',
    'Tillamook',
    'Umatilla',
    'Union',
    'Wallowa',
    'Wasco',
    'Washington',
    'Wheeler',
    'Yamhill',
    ]